import React, { useState } from "react";
import { FaHandPointRight } from "react-icons/fa";
import "../Responsive.css";

const ExperienceCards = () => {
  const [activeSection, setActiveSection] = useState(0);

  const experiences = [
    {
      id: 0,
      company: "Capgemini",
      role: "Software Engineer",
      date: "September 2025 - Present",
      points: [
        "Developing Java Full Stack applications using Spring Boot and Angular, building RESTful APIs and implementing database integration for enterprise-level solutions.",
        "Collaborating in Agile/Scrum environment, ensuring code quality through debugging, testing, and code reviews, contributing to continuous delivery of production-ready features."
      ]
    },
    {
      id: 1,
      company: "Barclays",
      role: "Technology Summer Intern",
      date: "June 2024 - July 2024",
      points: [
        "Developed RESTful APIs using Spring Boot for Client Lifecycle Management, improving response time by 60% for over 1000 daily client requests.",
        "Led documentation and implementation of OpenAPI Specifications (OAS), reducing integration issues by 50% and ensuring high-quality software delivery using Agile methodologies."
      ]
    },
    {
      id: 2,
      company: "SUD Life Insurance",
      role: "Software Developer",
      date: "June 2023 - Present",
      points: [
        "Contributed to backend connectivity and API implementation.",
        "Collaborated with senior developers to implement system improvements.",
        "Committed to project completion and team success."
      ]
    },
    {
      id: 3,
      company: "QuestIT VESIT",
      role: "Deputy Secretary",
      date: "August 2023 - Present",
      points: [
        "Managed a team of 50 students including batchmates and juniors.",
        "Successfully organized Invictus Hackathon from planning to execution.",
        "trained 140+ students regarding Mini project Ideas."
      ]
    },
    {
      id: 4,
      company: "ISTE VESIT",
      role: "Operations Officer",
      date: "January 2023 - Present",
      points: [
        "Organized technical and fun events to boost student participation.",
        "Managed the organizing team during PRAXIS technical fest.",
        "Conducted flagship event 'DALAL STREET' with 200+ participants."
      ]
    },
    {
      id: 5,
      company: "VESLANG CIRCLE",
      role: "Junior Mentor",
      date: "July 2022 - May 2023",
      points: [
        "Mentored juniors for personality development and placements.",
        "Conducted group tasks and corrected mentees.",
        "Taught public speaking skills to student groups."
      ]
    },
    {
      id: 6,
      company: "SORT VESIT",
      role: "SoRT Incharge",
      date: "January 2022 - June 2022",
      points: [
        "Orchestrated class activities for social work contribution.",
        "Motivated students to contribute towards charity for the poor.",
        "Cultivated an organizational environment."
      ]
    }
  ];

  return (
    <div className="flex flex-col md:flex-row justify-center items-start mt-10 text-white min-h-[500px]">
      {/* Tabs Column */}
      <div className="w-full md:w-1/4 flex flex-row md:block overflow-x-auto md:overflow-visible mb-8 md:mb-0 md:mr-8 pb-4 md:pb-0 border-b md:border-b-0 border-white/10 scrollbar-hide">
        {experiences.map((exp, index) => (
          <button
            key={index}
            onClick={() => setActiveSection(index)}
            className={`text-left px-4 py-3 md:py-4 transition-all duration-300 font-serif text-lg md:text-xl
              whitespace-nowrap md:whitespace-normal
              min-w-[120px] md:w-full block shrink-0
              border-b-2 md:border-b-0 md:border-l-2
              ${activeSection === index
                ? "border-purple-500 text-white bg-white/10"
                : "border-transparent md:border-gray-700 text-gray-400 hover:text-white hover:bg-white/5"
              }`}
          >
            {exp.company}
          </button>
        ))}
      </div>

      {/* Content Column */}
      <div className="w-full md:w-2/3 bg-white/5 p-6 rounded-xl border border-white/10 backdrop-blur-sm min-h-[400px]">
        <h3 className="text-3xl font-bold text-white mb-1">
          {experiences[activeSection].role}
        </h3>
        <p className="text-purple-400 font-mono mb-6">
          @ {experiences[activeSection].company} | {experiences[activeSection].date}
        </p>

        <div className="space-y-4">
          {experiences[activeSection].points.map((point, i) => (
            <div key={i} className="flex items-start">
              <FaHandPointRight className="text-purple-500 mt-1 mr-3 min-w-[20px]" />
              <p className="text-gray-300 text-sm leading-relaxed">
                {point}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExperienceCards;
